function createStickyScopeForNavigation() {
  const nav = document.querySelector('.l-navigation');
  if (!nav) return;

  // Берём только табы, которые соответствуют секциям (исключая PDF/Quote)
  const tabs = Array.from(nav.querySelectorAll('.c-tabs__item[data-id-section]'));
  if (!tabs.length) return;

  // Собираем секции ровно в порядке вкладок
  const sectionIds = tabs.map((t) => t.dataset.idSection?.replace(/^#/, '')).filter(Boolean);

  const sections = sectionIds.map((id) => document.getElementById(id)).filter(Boolean);

  if (!sections.length) return;

  const firstSection = sections[0];
  const lastSection = sections[sections.length - 1];

  // Если уже есть наш wrapper — не дублируем
  if (firstSection.closest('.l-navigation-scope')) return;

  // Проверим, что первая и последняя секции — в одном родителе
  const parent = firstSection.parentElement;
  if (!parent || lastSection.parentElement !== parent) {
    // Если у вас другая структура, можно придумать общий контейнер иначе
    console.warn('[createStickyScopeForNavigation] First/last sections are not siblings of same parent.');
  }

  // Создаём wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'l-navigation-scope';
  // Чтобы sticky ограничивался wrapper’ом — достаточно position: relative у wrapper'а:
  wrapper.style.position = 'relative';
  wrapper.style.width = '100%';

  // Вставляем wrapper ПЕРЕД первой секцией
  parent.insertBefore(wrapper, firstSection);

  // Соберём все подряд идущие элементы от первой до последней (включая)
  const rangeNodes = [];
  let cur = firstSection;
  while (cur) {
    rangeNodes.push(cur);
    if (cur === lastSection) break;
    cur = cur.nextElementSibling;
  }

  // Переносим эти узлы внутрь wrapper (сохраняется порядок)
  rangeNodes.forEach((node) => wrapper.appendChild(node));

  // Переносим навигацию внутрь wrapper.
  // Куда ставить — решайте по дизайну. Чаще удобно в начало wrapper'а:
  wrapper.insertBefore(nav, wrapper.firstChild);

  // --- Необязательное: сохранить высоту в старом месте, чтобы не было сдвига layout
  // Если заметили скачок — раскомментируйте:
  // const ph = document.createElement('div');
  // ph.style.height = nav.getBoundingClientRect().height + 'px';
  // nav.parentElement.insertBefore(ph, nav.nextSibling);
}

const MQ_BP = 992;
const isNarrow = () => window.innerWidth < MQ_BP;

function computeScrollTop(target, { offsetTop = 200, bottomAlign = false }) {
  const rect = target.getBoundingClientRect();
  const absTop = rect.top + window.scrollY;
  const absBottom = rect.bottom + window.scrollY;

  const doc = document.documentElement;
  const maxScroll = Math.max(0, (doc.scrollHeight || document.body.scrollHeight) - window.innerHeight);

  if (isNarrow() || !bottomAlign) {
    const top = absTop - offsetTop;
    return Math.min(Math.max(0, top), maxScroll);
  }

  const top = Math.min(absBottom - window.innerHeight + offsetTop, maxScroll);
  return Math.max(0, top);

  // if (bottomAlign) {
  //   // выравниваем нижнюю границу viewport к нижней границе секции
  //   // clamp чтобы не уезжать за пределы документа
  //   const top = Math.min(absBottom - window.innerHeight + offsetTop, maxScroll);
  //   return Math.max(0, top);
  // } else {
  //   // стандартно: верх секции к верху viewport с учётом offset
  //   const top = absTop - offsetTop;
  //   // тоже не даём выехать за низ документа
  //   return Math.min(Math.max(0, top), maxScroll);
  // }
}

function initNavigationActiveHighlight() {
  const nav = document.querySelector('.l-navigation');
  if (!nav) return;

  const tabs = Array.from(nav.querySelectorAll('.c-tabs__item[data-id-section]'));
  if (!tabs.length) return;

  const bottomAlignIds = new Set(['key-facts', 'featured-itineraries']);

  // IDs секций в порядке табов
  const ids = tabs.map((t) => (t.dataset.idSection || '').replace(/^#/, '')).filter(Boolean);
  const sections = ids.map((id) => document.getElementById(id)).filter(Boolean);
  if (!sections.length) return;

  // Быстрые мапы: id -> tab / section
  // const tabById = new Map(tabs.map((t) => [(t.dataset.idSection || '').replace(/^#/, ''), t]));
  const sectionById = new Map(sections.map((s) => [s.id, s]));

  const setActive = (id) => {
    tabs.forEach((t) => t.classList.toggle('is-active', (t.dataset.idSection || '').replace(/^#/, '') === id));
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      const id = (tab.dataset.idSection || '').replace(/^#/, '');
      const target = sectionById.get(id);
      if (!target) return;

      const bottomAlign = bottomAlignIds.has(id);
      const top = computeScrollTop(target, { offsetTop: 50, bottomAlign });

      window.scrollTo({ top, behavior: 'smooth' });
      // setActive(id); // если нужна мгновенная подсветка
    });
  });

  // Плавный скролл по клику
  // tabs.forEach((tab) => {
  //   tab.addEventListener('click', (e) => {
  //     e.preventDefault();
  //     const id = (tab.dataset.idSection || '').replace(/^#/, '');
  //     const target = sectionById.get(id);
  //     if (!target) return;

  //     const offset = 200; // при необходимости подстрой под ваш хедер
  //     const top = target.getBoundingClientRect().top + window.scrollY - offset;
  //     window.scrollTo({ top, behavior: 'smooth' });
  //     // setActive(id); // мгновенная подсветка
  //   });
  // });

  // Подсветка по скроллу: берём секцию, центр которой ближе к центру вьюпорта
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      const viewportMiddle = window.scrollY + window.innerHeight - 100;

      let bestId = null;
      let bestDist = Infinity;

      for (const s of sections) {
        const r = s.getBoundingClientRect();
        // учитываем только те, что пересекаются с вьюпортом
        if (r.bottom <= 0 || r.top >= window.innerHeight) continue;

        const sectionMiddle = window.scrollY + r.top + r.height / 2;
        const dist = Math.abs(sectionMiddle - viewportMiddle);

        if (dist < bestDist) {
          bestDist = dist;
          bestId = s.id;
        }
      }

      if (bestId) setActive(bestId);
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', onScroll);
  onScroll(); // первичная инициализация
}

// Вызвать после того, как есть DOM и блок навигации
document.addEventListener('DOMContentLoaded', () => {
  createStickyScopeForNavigation();
  initNavigationActiveHighlight();
});
